"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yahooPublished = exports.yahooArticleFilename = exports.yahooArticleErrors = exports.plainText = void 0;
const xmlSafeText_1 = require("../xmlSafeText");
const YahooArticle_1 = require("../../YahooArticle");
// File name pattern \d[0-9A-Z]\d[0-9A-Z]-YYYYMMDD-article.xml (new JPX codes included).
const TICKER = /^\d[0-9A-Z]\d[0-9A-Z]$/;
const MAX_REVISION = 9999;
// Only what looks like an HTML tag: the spec strips <strong>/<a> and the like,
// while text such as "売上 < 100" must survive.
const HTML_TAG = /<\/?[a-zA-Z][a-zA-Z0-9-]*(\s[^<>]*)?\/?>/g;
const plainText = (text) => (0, xmlSafeText_1.xmlSafeText)(text.replace(HTML_TAG, '')).trim();
exports.plainText = plainText;
const blockLabel = (section, index) => `${section} ${index + 1} 番目`;
const itemErrors = (items, section) => items.flatMap((item, index) => {
    const at = blockLabel(section, index);
    if (item.type === 'Img') {
        const missing = [!item.src && '画像', !(item.width > 0) && '幅', !(item.height > 0) && '高さ', !item.alt?.trim() && '図のタイトル(alt)'].filter(Boolean);
        return missing.length ? [`${at}の画像: ${missing.join('・')}がありません`] : [];
    }
    if (item.type === 'Header' && !['h1', 'h2', 'h3', 'h4', 'h5'].includes(item.level))
        return [`${at}の見出し: レベルが不正です`];
    return (0, exports.plainText)(item.text ?? '') === '' ? [`${at}: 文章が空です`] : [];
});
// Everything Yahoo requires, in words an analyst can act on.
const yahooArticleErrors = (input) => {
    const { content } = input;
    const errors = [];
    if (!TICKER.test(input.ticker))
        errors.push(`証券コード「${input.ticker}」は Yahoo のファイル名の形式（4 文字）に合いません`);
    if (Number.isNaN(input.publishedAt.getTime()))
        errors.push('公開日時がありません');
    if (!Number.isInteger(input.revisionId) || input.revisionId < 1 || input.revisionId > MAX_REVISION)
        errors.push(`版数は 1〜${MAX_REVISION} です（${input.revisionId}）`);
    if (content.keyPoints?.some((point) => (0, exports.plainText)(point) === ''))
        errors.push('キーポイントに空の行があります');
    if (content.summary.length === 0)
        errors.push('要約が 1 つもありません');
    if (content.article.length === 0)
        errors.push('本文が 1 つもありません');
    errors.push(...itemErrors(content.summary, '要約'), ...itemErrors(content.article, '本文'));
    if (content.surveyLinkUrl && !/^https:\/\/\S+$/.test(content.surveyLinkUrl))
        errors.push('アンケートURLは https:// で始まる URL です');
    if (!input.analyst.name.trim() || !input.analyst.affiliation.trim())
        errors.push('アナリスト情報（各種しきい値の YAHOO_ANALYST）に名前と肩書が必要です');
    return errors;
};
exports.yahooArticleErrors = yahooArticleErrors;
const yahooArticleFilename = (ticker, publishedAt) => `${ticker}-${(0, YahooArticle_1.jstDate)(publishedAt).replace(/-/g, '')}-article.xml`;
exports.yahooArticleFilename = yahooArticleFilename;
// ISO 8601 local JST without an offset, as the spec's example (2025-11-12T17:00:00).
const yahooPublished = (publishedAt) => new Date(publishedAt.getTime() + YahooArticle_1.JST_OFFSET_MS).toISOString().slice(0, 19);
exports.yahooPublished = yahooPublished;
